import { thunkGetAppConfig, thunkGetAreaTree, thunkGetPermissionList } from 'app/appSlice';
import AccountHelper from 'features/Account/accountHelper';
import AuthHelper from 'features/Auth/authHelper';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import RoleUtils from 'general/utils/RoleUtils';
import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function DataCommonListener(props) {
  // MARK: --- Params ---
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  // MARK: --- Hooks ---
  useEffect(() => {
    if (AuthHelper.checkAccessTokenValid()) {
      AccountHelper.callApiGetProfile();
    }

    return () => {};
  }, []);

  useEffect(() => {
    if (!_.isEmpty(user)) {
      const savedUiMode = localStorage.getItem(PreferenceKeys.savedUiMode);
      if (RoleUtils.isCustomerUiRole(user?.role, savedUiMode)) return;

      // lay ds khu vuc
      dispatch(thunkGetAreaTree({}));
      // lay app config
      dispatch(thunkGetAppConfig());
      // lay ds permission group
      dispatch(thunkGetPermissionList());
    }
  }, [user]);

  return <></>;
}

export default DataCommonListener;
